import { ConfigProvider, ConfigProviderProps, theme } from 'antd';
import React from 'react';

import zhCN from 'antd/locale/zh_CN';
import enUS from 'antd/locale/en_US';
import arEG from 'antd/locale/ar_EG';
import ruRU from 'antd/locale/ru_RU';

const { useToken } = theme;

// 使用 zh、en、ru 2025-09-02
const messages: { [key in string]: any } = {
  zh: zhCN,
  en: enUS,
  ar: arEG,
  ru: ruRU,
};

export interface ILocalAntdConfigProviderProps extends Omit<ConfigProviderProps, 'locale'> {
  language: string;
}

const LocalAntdConfigProvider: React.FC<ILocalAntdConfigProviderProps> = (props) => {
  const { children, language, direction, theme, ...otherProps } = props;
  const { token } = useToken();
  return (
    <ConfigProvider
      locale={messages[language.split('_')[0]]}
      direction={direction || 'ltr'}
      theme={{
        token: {
          colorPrimary: '#019e9c',
          colorBgContainerDisabled: 'rgba(0,0,0,0.1)',
          colorInfo: '#155FF5',
          colorLink: '#155FF5',
          colorBgLayout: '#F1F2F3',
          colorTextDisabled: 'rgba(0,0,0,0.35)',
        },
        components: {
          Table: {
            cellPaddingInlineSM: token.paddingXXS,
            cellPaddingBlockSM: token.paddingXXS,
          },
          Cascader: {
            dropdownHeight: 300,
          },
          Button: {
            primaryShadow: 'none',
          },
          Layout: {
            headerBg: '#fff',
            headerHeight: 62,
            siderBg: '#fff',
            borderRadius: 4,
          },
          Tooltip: {
            colorBgSpotlight: 'rgb(255,255,255)',
            colorTextLightSolid: 'rgba(0,0,0,0.85)',
          },
        },
        ...theme,
      }}
      {...otherProps}
    >
      {children}
    </ConfigProvider>
  );
};

export default LocalAntdConfigProvider;
